'use strict';
'use es6';

// used to dispatch error actions and then re-throw to bubble up Error

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dispatchAndLogError = exports.dispatchAndLogError = function dispatchAndLogError(_ref) {
  var dispatch = _ref.dispatch,
      type = _ref.type,
      error = _ref.error;

  dispatch({
    type: type,
    payload: {
      error: error
    }
  });

  throw error;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/dispatchAndLogError.js
// module id = 150
// module chunks = 3 4